/**
 * Skills
 * Rôle:
 * - Afficher les compétences techniques regroupées par grandes catégories à partir du JSON `skills.json`.
 *
 * Responsabilités principales:
 * - Parcourir les groupes et lister les compétences avec leur niveau.
 * - Rester simple et lisible sur mobile comme sur desktop.
 *
 * Évolutions attendues:
 * - Ajouter une légende des niveaux et éventuellement un tri/filtre par domaine.
 * - Brancher ces données sur d’autres vues (timeline, PNJ, etc.).
 */
import skills from '@/content/skills.json'

type SkillItem = { name: string; level: 'faible' | 'moyen' | 'avancé'; icon?: string }
type SkillGroup = { group: string; items: SkillItem[] }

type Props = {
  variant?: 'default' | 'lite'
}

export default function Skills({ variant = 'default' }: Props) {
  const groups = (skills as SkillGroup[]) || []
  if (!groups.length) return null
  const isLite = variant === 'lite'
  return (
    <div className="space-y-4">
      <h2 className={isLite ? 'text-2xl font-extrabold italic tracking-tight text-slate-100' : 'text-xl font-semibold'}>
        Compétences
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {groups.map((g) => (
          <div
            key={g.group}
            className={
              isLite
                ? 'lite-card rounded-2xl p-5 space-y-2'
                : 'rounded-lg border border-slate-800 bg-slate-900/40 p-4 space-y-2'
            }
          >
            <div className={isLite ? 'text-xs tracking-widest uppercase text-slate-400' : 'text-sm text-slate-400'}>
              {g.group}
            </div>
            <ul className="flex flex-wrap gap-2">
              {g.items.map((it) => (
                <li
                  key={it.name}
                  className={
                    isLite
                      ? 'rounded-xl border border-slate-700 bg-slate-950/25 px-3 py-1 text-sm text-slate-200'
                      : 'rounded-md border border-slate-800 bg-slate-900/60 px-3 py-1 text-sm'
                  }
                  title={`Niveau: ${it.level}`}
                >
                  <span className={isLite ? 'font-semibold text-slate-100' : 'text-slate-200'}>{it.name}</span>
                  {/* <span className={isLite ? 'ml-2 text-xs text-slate-400' : 'ml-2 text-xs text-slate-400'}>
                    ({it.level})
                  </span> */}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}


